export const local_storage_keys = {
  GIFT_INFO_CONTEXT: "gift-info-context",
  PAYMENT_CONTEXT: "payment-context",
  USER_INFO_CONTEXT: "user-info-context",
  FILTERS_CONTEXT: "filters-context",
  CONVERSATION_TICKET: "conversation-ticket",
};
